import { LeaderboardView } from '../../../components/worldcup/LeaderboardView/LeaderboardView';

export default function WorldCupLeaderboardRoute() {
  return <LeaderboardView />;
}
